var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [
            _vm.mode === "database"
              ? [_vm._v(" Add Database User ")]
              : [_vm._v(" Add User Database ")]
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _vm.mode === "database"
                              ? [
                                  _vm._v(
                                    " Adding a User to the database “" +
                                      _vm._s(_vm.database) +
                                      "”. "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    " Adding a database privileges for the user “" +
                                      _vm._s(_vm.user) +
                                      "”. "
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "pb-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _vm.mode === "database"
                          ? [
                              _vm.mysqlUsers.length
                                ? [
                                    _c("gg-select", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "select-user",
                                      attrs: {
                                        label: "Select Database User",
                                        placeholder: "Select a User",
                                        loading: _vm.loadingUsers,
                                        disabled: _vm.loadingPrivileges,
                                        items: _vm.mysqlUsers,
                                        "item-text": "user",
                                        "data-vv-name": "user",
                                        "data-vv-as": "User",
                                        "error-messages": _vm.errors.collect(
                                          "user"
                                        )
                                      },
                                      model: {
                                        value: _vm.selectedUser,
                                        callback: function callback($$v) {
                                          _vm.selectedUser = $$v
                                        },
                                        expression: "selectedUser"
                                      }
                                    }),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "hosting_mysql_users"
                                          }
                                        }
                                      },
                                      [_vm._v(" Create a new database user. ")]
                                    )
                                  ]
                                : _c(
                                    "p",
                                    [
                                      _vm._v(
                                        " You currently have no active database users. "
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "hosting_mysql_users",
                                              query: _vm.$route.query
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Create a new database user. "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                            ]
                          : _c("gg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                label: "Database",
                                placeholder: "Select a Database",
                                dense: "",
                                outlined: "",
                                loading: _vm.loadingDatabases,
                                disabled: _vm.loadingPrivileges,
                                items: _vm.mysqlDatabases,
                                "item-text": "db",
                                "data-vv-name": "database",
                                "data-vv-as": "Database",
                                "error-messages": _vm.errors.collect("database")
                              },
                              model: {
                                value: _vm.selectedDatabase,
                                callback: function callback($$v) {
                                  _vm.selectedDatabase = $$v
                                },
                                expression: "selectedDatabase"
                              }
                            })
                      ],
                      2
                    ),
                    _vm.loadingPrivileges
                      ? _c(
                          "v-col",
                          {
                            staticClass: "text-center",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                size: "64",
                                indeterminate: "",
                                color: "primary"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-expand-transition",
                      [
                        !_vm.loadingPrivileges &&
                        (_vm.selectedDatabase || _vm.selectedUser)
                          ? _c(
                              "v-col",
                              {
                                staticClass: "mb-4",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "py-0",
                                        attrs: {
                                          cols: "12"
                                        }
                                      },
                                      [
                                        _c("v-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "d-none",
                                          attrs: {
                                            value: _vm.userPrivileges.join(""),
                                            name: "User Privileges",
                                            "data-vv-name": "privileges",
                                            "data-vv-as": "User Privileges"
                                          }
                                        }),
                                        _c("v-switch", {
                                          attrs: {
                                            color: "primary",
                                            label: "All Privileges",
                                            "error-messages": _vm.errors.collect(
                                              "privileges"
                                            )
                                          },
                                          on: {
                                            click: _vm.toggleAll
                                          },
                                          model: {
                                            value: _vm.allPrivilegesInit,
                                            callback: function callback($$v) {
                                              _vm.allPrivilegesInit = $$v
                                            },
                                            expression: "allPrivilegesInit"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._l(_vm.mysqlPrivileges, function(
                                      privilege
                                    ) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: privilege,
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              label: privilege,
                                              value: privilege,
                                              color: "primary",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.userPrivileges,
                                              callback: function callback($$v) {
                                                _vm.userPrivileges = $$v
                                              },
                                              expression: "userPrivileges"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _vm.mysqlUsers.length
              ? _c(
                  "gg-btn",
                  {
                    attrs: {
                      loading: _vm.loading
                    },
                    on: {
                      click: _vm.submit
                    }
                  },
                  [_vm._v(" Save Privileges ")]
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }